import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Input, Component, OnInit, OnDestroy } from '@angular/core';

import { UserSessionService } from './services';

import {
  Login,
  StundenService,
  Stunden
} from '@proffix/restapi-angular-library';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  APP_VERSION = '0.5.1';

  proffixLogin: Login = null;
  mitarbeiterNr: number;
  isRunningWithQueryStringLogin: boolean;

  isLogVisible = false;
  logMessages: ILog[] = [];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _stundenService: StundenService,
    private _userSessionService: UserSessionService) {
  }

  ngOnInit(): void {
    // enable login by using query string parameters
    this._activatedRoute.queryParams.subscribe(params => {
      const username = params['username'];
      const password = params['password'];

      if (this.isRunningWithQueryStringLogin != true && username && password && (this.proffixLogin == null || this.proffixLogin.Benutzer != username)) {
        this.isRunningWithQueryStringLogin = true; // avoid sending the login multiple times

        this._userSessionService.sendLogin(username, password).subscribe(() => {
          this._userSessionService.checkLogin();
        });
      }
    });

    this.registerLogListener();

    this._userSessionService.getProffixLogin().subscribe(data => {
      this.proffixLogin = data;
    });

    this._userSessionService.checkLogin();
  }

  ngOnDestroy(): void {
    this._userSessionService.logout();
  }

  logout() {
    this._userSessionService.logout().subscribe(() => {

      alert("subscribe");
      //      this._router.navigate(['login']);
    });

    this._userSessionService.logout().finally(() => {
      alert("finally");
    });
    //window.location.reload();
  }

  registerLogListener() {
    const log = console.log;
    const that = this;

    console.log = function (msg) {
      try {
        that.appendLogMessage('log', msg, JSON.stringify(arguments));
        log.apply(this, Array.prototype.slice.call(arguments));
      } catch (ex) { }
    };
    console.error = function (msg) {
      try {
        that.appendLogMessage('error', msg, JSON.stringify(arguments));
        log.apply(this, Array.prototype.slice.call(arguments));
      } catch (ex) { }
    };
    console.warn = function (msg) {
      try {
        that.appendLogMessage('warn', msg, JSON.stringify(arguments));
        log.apply(this, Array.prototype.slice.call(arguments));
      } catch (ex) { }
    };
    console.info = function (msg) {
      try {
        that.appendLogMessage('info', msg, JSON.stringify(arguments));
        log.apply(this, Array.prototype.slice.call(arguments));
      } catch (ex) { }
    };
  }

  appendLogMessage(type: string, message: string, args: string): void {
    this.logMessages.unshift({
      date: new Date(),
      type: type,
      message: message,
      arguments: args,
    });
  }
}

export interface ILog {
  date: Date;
  type: string;
  message: string;
  arguments: string;
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/app.component.ts